import makeActionCreator from '../../utils/makeActionCreator'
import fetch from 'isomorphic-fetch'
import { sessionService } from 'redux-react-session';
import { browserHistory } from 'react-router'

import * as API       from '../../utils/config-api'
import * as endpoints from './endpoints'
import { logout } from '../../auth/list';

export const SETTINGS_RATES_PENDING = 'SETTINGS_RATES_PENDING'
export const settingsRatesPending = makeActionCreator(SETTINGS_RATES_PENDING)

export const SETTINGS_RATES_REJECTED = 'SETTINGS_RATES_REJECTED'
export const settingsRatesRejected = makeActionCreator(SETTINGS_RATES_REJECTED)

export const SETTINGS_RATES_SHOW_LIST= 'SETTINGS_RATES_SHOW_LIST'
export const settingsRatesShowList = makeActionCreator(SETTINGS_RATES_SHOW_LIST)

export const SETTINGS_RATES_HIDE_LIST = 'SETTINGS_RATES_HIDE_LIST'
export const settingsRatesHideList = makeActionCreator(SETTINGS_RATES_HIDE_LIST)

export const SETTINGS_RATES_SHOW_FORM= 'SETTINGS_RATES_SHOW_FORM'
export const settingsRatesShowForm = makeActionCreator(SETTINGS_RATES_SHOW_FORM, 'itemId')

export const SETTINGS_RATES_HIDE_FORM = 'SETTINGS_RATES_HIDE_FORM'
export const settingsRatesHideForm = makeActionCreator(SETTINGS_RATES_HIDE_FORM)

export const SETTINGS_RATES_SHOW_ITEM = 'SETTINGS_RATES_SHOW_ITEM'
export const settingsRatesShowItem = makeActionCreator(SETTINGS_RATES_SHOW_ITEM, 'itemId')


//Show Index

export const SETTINGS_RATES_LIST_FULFILLED = 'SETTINGS_RATES_LIST_FULFILLED'
export const settingsRatesListFulfilled = makeActionCreator(SETTINGS_RATES_LIST_FULFILLED, 'data')

export const SETTINGS_RATES_LIST_ERROR = 'SETTINGS_RATES_LIST_ERROR'
export const settingsRatesListError = makeActionCreator(SETTINGS_RATES_LIST_ERROR, 'message')

export function settingsRatesList(roleId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRatesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.index.version}${endpoints.index.path.replace(":user_role_id", roleId)}`, {
              method  : endpoints.index.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingsRatesListFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRatesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}


//Show Item

export const SETTINGS_RATES_ITEM_FULFILLED = 'SETTINGS_RATES_ITEM_FULFILLED'
export const settingsRatesItemFulfilled = makeActionCreator(SETTINGS_RATES_ITEM_FULFILLED, 'data')

export const SETTINGS_RATES_ITEM_ERROR = 'SETTINGS_RATES_ITEM_ERROR'
export const settingsRatesItemError = makeActionCreator(SETTINGS_RATES_ITEM_ERROR, 'message')

export function settingsRatesItem(roleId, itemId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRatesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.getItem.version}${endpoints.getItem.path.replace(":user_role_id", roleId).replace(":user_role_rate_id", itemId)}`, {
              method  : endpoints.getItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => dispatch(settingsRatesItemFulfilled(json.data)) )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRatesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));
    })



  }
}


//Add Item

export const SETTINGS_RATES_ITEM_ADD_FULFILLED = 'SETTINGS_RATES_ITEM_ADD_FULFILLED'
export const settingsRatesItemAddFulfilled = makeActionCreator(SETTINGS_RATES_ITEM_ADD_FULFILLED, 'data')

export const SETTINGS_RATES_ITEM_ADD_ERROR = 'SETTINGS_RATES_ITEM_ADD_ERROR'
export const settingsRatesItemAddError = makeActionCreator(SETTINGS_RATES_ITEM_ADD_ERROR, 'message')

export function settingsRatesAddItem(data) {
  let formData = new FormData()
  let roleId = data["user_level_id"]

  formData.append("start_date", data["start_date"]);
  formData.append("hourly_rate", data["hourly_rate"]);

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRatesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.addItem.version}${endpoints.addItem.path.replace(":user_role_id", roleId)}`, {
              method  : endpoints.addItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              },
              body: formData
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
              if(json.status === "ok"){
                dispatch(settingsRatesItemAddFulfilled(json.data))
              }else{
                dispatch(settingsRatesItemAddError(json.message))
              }
          } )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRatesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

//Update Item

export const SETTINGS_RATES_ITEM_UPDATE_FULFILLED = 'SETTINGS_RATES_ITEM_UPDATE_FULFILLED'
export const settingsRatesItemUpdateFulfilled = makeActionCreator(SETTINGS_RATES_ITEM_UPDATE_FULFILLED, 'data')

export const SETTINGS_RATES_ITEM_UPDATE_ERROR = 'SETTINGS_RATES_ITEM_UPDATE_ERROR'
export const settingsRatesItemUpdateError = makeActionCreator(SETTINGS_RATES_ITEM_UPDATE_ERROR, 'message')

export function settingsRatesUpdateItem(itemId, data) {
  let formData = new FormData()
  let roleId = data["user_level_id"]

  formData.append('_method', 'PUT')
  formData.append("start_date", data["start_date"]);
  formData.append("hourly_rate", data["hourly_rate"]);


  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRatesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.updateItem.version}${endpoints.updateItem.path.replace(":user_role_id", roleId).replace(":user_role_rate_id", itemId)}`, {
              method  : endpoints.updateItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              },
              body: formData
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
              if(json.status === "ok"){
                dispatch(settingsRatesItemUpdateFulfilled(json.data))
              }else{
                dispatch(settingsRatesItemUpdateError(json.message))
              }
          } )
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRatesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })



  }
}

//Delete Item

export const SETTINGS_RATES_ITEM_DELETE_FULFILLED = 'SETTINGS_RATES_ITEM_DELETE_FULFILLED'
export const settingsRatesItemDeleteFulfilled = makeActionCreator(SETTINGS_RATES_ITEM_DELETE_FULFILLED, 'data')

export const SETTINGS_RATES_ITEM_DELETE_ERROR = 'SETTINGS_RATES_ITEM_DELETE_ERROR'
export const settingsRatesItemDeleteError = makeActionCreator(SETTINGS_RATES_ITEM_DELETE_ERROR, 'message')

export function settingsRatesDeleteItem(roleId, itemId) {

  return dispatch => {
    sessionService.loadSession().then(currentSession => {
      dispatch(settingsRatesPending())

          return fetch(`${API.config.domain}${API.config.apiPreUrl}${endpoints.deleteItem.version}${endpoints.deleteItem.path.replace(":user_role_id", roleId).replace(":user_role_rate_id", itemId)}`, {
              method  : endpoints.deleteItem.method,
              headers : {
                  'Authorization' : `Bearer ${currentSession.token}`,
                  'Accept': 'application/json'
              }
          })
          .then( API.checkStatus )
          .then( API.parseJSON )
          .then( json => {
            if(json.status === "ok"){
              dispatch(settingsRatesItemDeleteFulfilled(json.data))
              dispatch(settingsRatesList(roleId))
            }else{
              dispatch(settingsRatesItemDeleteError(json.message))
            }

          })
          .catch( err => {
              // Dispatch the error action with error information
              dispatch(settingsRatesRejected(err))
          })
    })
    .catch(err => {
      dispatch(logout(() => browserHistory.push('/login')));

    })





  }
}
